import React from "react";
import "./about1.css";
import bg from "../../assets/images/About/shape-section1.png";
const AboutSection = () => {
    return (
        <section className="about-section1" style={{ backgroundImage: `url(${bg})` }}>
            
            <div className="about-container1">
                <div className="about-box1">
                    <h3>Experience</h3>
                    <p>
                        With 20+ years of hands-on experience, our team of seasoned professionals brings a wealth of expertise to every project. From web development and design to bespoke software solutions, we harness the power of technology to drive success for our clients.
                    </p>
                </div>

                <div className="about-box1">
                    <h3>Innovation</h3>
                    <p>
                      In the fast-paced world of IT, staying ahead requires continuous innovation. At Horizon Webinfo, we pride ourselves on our ability to embrace emerging technologies and incorporate them into our solutions, ensuring that our clients are always at the forefront of industry trends.
                    </p>
                </div>

                <div className="about-box1">
                    <h3>Customer-Centric Approach</h3>
                    <p>
                        We believe in building lasting relationships with our clients. Our customer-centric approach is woven into the fabric of our company culture, ensuring that we not only meet but exceed the expectations of those we serve.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;
